// @ts-check
import { graphql } from 'gatsby';
import React from 'react';
import { GetCopyFromJson } from '~/contentstack/rendering';

export const query = graphql`
	fragment TextSectionFragment on Ozk_content_blockModular_blocksCopyContent {
		text {
			text_color
			copy {
				json
			}
		}
	}
`;

/**
 * @typedef TextOptions
 * @property {string} text_color
 * @property {import('../CSTypes').CSJRTE[]} copy
 * 
 * @typedef TextProps
 * @property {import('~/contentstack/types').ModelWithLivePreviewAttr<TextOptions>} [options]

 * @param {TextProps} props
 */
const TextSection = ({ options }) => {
	const output = GetCopyFromJson(options.copy);

	return (
		<div className="text-section" style={{ color: options.text_color }} {...options.$?.text_color}>
			{output}
		</div>
	);
};

export default TextSection;
